import React from "react";
import GuidesGrid from "../components/bookYourGuide/GuidesGrid";
import Styles from "./BookYourGuide.module.css";
import PlanYourTrip from "../components/bookYourGuide/planYourTrip/PlanYourTrip";
import GoToTop from "../components/GotoTop";

function BookYourGuide() {
	return (
		<div>
			<div className={Styles.padding}></div>
			<GuidesGrid />
			<PlanYourTrip />
			<GoToTop />
		</div>
	);
}

export default BookYourGuide;
